import {Environment, RecordSource, Store} from 'relay-runtime';
import network from './services/network';

const source = new RecordSource();
const store = new Store(source);
const handlerProvider = null; // Use default

const environment = new Environment({
  handlerProvider,
  network,
  store,
});

export default environment;



// WEBPACK FOOTER //
// ./src/data/environment.js